function setSessionStorageItem(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    if (e.code === 22) {
      console.log('Session storage full.');
    }
  }
}

function getSessionStorageItem(key) {
  const item = sessionStorage.getItem(key);
  if (!item) return null;
  return JSON.parse(item);
}

export { setSessionStorageItem, getSessionStorageItem };

export const SESSION_STORAGE_AUTH_TOKEN = "AUTH_TOKEN";
export const SESSION_STORAGE_ENVIRONMENT = "ENVIRONMENT";
export const SESSION_STORAGE_QUOTER_ACTIVE_TAB = 'SESSION_STORAGE_QUOTER_ACTIVE_TAB';
